//#region libraries
import React from 'react';
// icons
import { MdFileDownload } from "react-icons/md";
//#endregion

const ExcelDownloadIcon = (props) => {
    return (
        <MdFileDownload onClick={props.onClick} size={28} color={'#B2B2B2'} style={props.style} />
    );
}

export default ExcelDownloadIcon;